import React from 'react';
import { Typography } from 'material-ui';
import { assets } from '../../../assets';
import Lottie from 'react-lottie';
import { CircularProgress } from '@material-ui/core';
import { convertKilometersToBestUnit } from '../../../utils/unitHelper';

export class AvoidedCO2ConvertedCar extends React.Component {
  render() {
    const {
      classes,
      t,
      user,
      avoidedCO2Grams,
      loading,
      co2_for_1km_driven_in_g,
    } = this.props;

    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    let avoidedCo2g = avoidedCO2Grams;

    let nbOfCarKmConversion = avoidedCo2g / co2_for_1km_driven_in_g;
    let [formattedValue, unitText] = convertKilometersToBestUnit(
      nbOfCarKmConversion,
      t,
      user
    );

    const myAnimatedCar = {
      loop: true,
      autoplay: true,
      animationData: assets.lottie.car,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <div>
        <div style={{ textAlign: 'center', align: 'center' }}>
          <Lottie options={myAnimatedCar} height={60} width={50} />
        </div>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
            {formattedValue} {unitText}
          </span>
        </Typography>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          {t('driven by an average passenger vehicle')}
        </Typography>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/ConvertedAvoidedCO2/AvoidedCO2ConvertedCar.js